import React from 'react';
import { Card, Placeholder } from 'semantic-ui-react';

import MediaActions from './MediaActions';

const PlaceholderCards = () => {
  const cards = [];
  for (let i = 0; i < 12; i++) {
    cards.push(
      <Card
        className="episode"
        key={`placeholder-${i}`}
        meta={
          <Placeholder>
            <Placeholder.Header>
              <Placeholder.Line />
            </Placeholder.Header>
          </Placeholder>
        }
        description={
          <Placeholder>
            <Placeholder.Paragraph>
              <Placeholder.Line />
              <Placeholder.Line />
              <Placeholder.Line />
            </Placeholder.Paragraph>
          </Placeholder>
        }
        extra={
          <MediaActions
            types={{ audio: true, video: true, pdf: true }}
            disabled
          />
        }
      />
    );
  }
  return cards;
};

export default PlaceholderCards;
